import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

/**
 * Keeps the R3F render loop alive when mobile browsers throttle or pause the default
 * loop (e.g. virtual keyboard open, input focus, compositor quirks behind scroll layers).
 */
export function BlobKeepAnimating() {
  const invalidate = useThree((state) => state.invalidate);

  useEffect(() => {
    let frameId = 0;
    const tick = () => {
      invalidate();
      frameId = requestAnimationFrame(tick);
    };
    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [invalidate]);

  return null;
}
